"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _Icon = _interopRequireDefault(require("./Icon/Icon"));

/*
 * Tip info message area
 *
 * <HtmlTip>
 * Your super helpful message here...
 * </HtmlTip>
 */
var HtmlTip = function HtmlTip(_ref) {
  var children = _ref.children,
      _ref$startIcon = _ref.startIcon,
      startIcon = _ref$startIcon === void 0 ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "graduation-cap",
    color: "default-light"
  }) : _ref$startIcon,
      boxProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "startIcon"]);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    p: 2,
    pl: 4,
    bgcolor: "green.fruitSaladLight",
    display: "flex"
  }, boxProps), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, null, startIcon), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    pl: 2,
    className: "Subcopy-Static-Alt"
  }, children)));
};

var _default = HtmlTip;
exports["default"] = _default;